<template>
  <div>
    <v-text-field label="انتخاب پنل کاربر" :value="packTitle" dense :disabled="disabled" outlined readonly
                  append-icon="mdi-crosshairs" class="cursor-pointer" @click="dialog = true" ref="input"
                  :error-messages="errors"/>

    <custom-popup v-model="dialog" :cons="{title: 'انتخاب پنل'}" scrollable max-width="800px" hide-confirm>
      <v-card flat outlined :loading="loading">

        <v-card-actions>
          <v-text-field label="جستجو" append-icon="mdi-magnify" v-model="tableProps.search" hide-details class="my-3"
                        outlined dense clear-icon="mdi-close-circle-outline" clearable @keydown.enter="reFetch"
                        @click:append="reFetch" @click:clear="clearFilter" :loading="loading"/>
        </v-card-actions>

        <v-list>
          <v-list-item @click="pick(x)" v-for="(x, i) in data.data" :key="i">
            <!--            <v-list-item-avatar>-->
            <!--              <v-avatar>-->
            <!--                &lt;!&ndash;                <v-img :src="x.image || `${$config.baseURL}/image/noData.svg`"/>&ndash;&gt;-->
            <!--                <v-list-item-title v-text="x.name"/>-->
            <!--              </v-avatar>-->
            <!--            </v-list-item-avatar>-->

            <v-list-item-content>
              <v-list-item-title v-text="x.title"/>
              <v-list-item-subtitle v-text="price(persian(x.price))+' تومان'">
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action v-if="x.id === value">
              <v-icon>mdi-check</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-divider/>
        <v-card-actions>
          <!--          <pagination :data="manufacturers.data" :visible="2" v-on:page="fetch"/>-->
          <!--          <Paginate :total="data.last_page" :links="data.links" :tableProps="tableProps"-->
          <!--                    @changePage="fetch(url, tableProps)"></Paginate>-->

          <pagination v-if="data && data.data" ref="pagination" :data="data" @page="onPagination"/>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </custom-popup>
  </div>
</template>

<script>
import pagination from "@/view/pages/pickers/pagination";
import routePagination from "@/view/content/route-pagination";
import Paginate from "@/view/pages/admin/Messages/Paginate";
import {qrAxios} from "@/main";

export default {
  components: {pagination, routePagination, Paginate},
  name: "packPicker",

  props: ['value', 'errors', 'disabled', 'packTitle'],

  model: {
    prop: 'value',
    event: 'manufacturersPicker'
  },

  computed: {
    manufacturer_name: function () {
      if (this.model === null) return "";
      return this.model.name;
    }
  },

  data: () => ({
    dialog: false,
    loading: false,
    manufacturers: [],
    data: {},
    model: null,
    tableProps: {
      page: 1,
      search: '',
      length: 7,
      column: 'id',
      dir: 'desc',
    },
  }),

  created() {
    this.fetch();
  },

  methods: {
    fetch(url = 'admin/pack', props = this.tableProps) {
      this.loading = true

      this.requestApiGet(url, props)
          .then(({data}) => {
            this.data = data
          })
          .catch(({response}) => this.$root.$emit('errorToast', response.data.message))
          .finally(() => this.loading = false);


    },
    reFetch() {
      this.tableProps.page = 1
      this.$nextTick(() => {
        this.fetch()
      })
    },
    clearFilter() {
      this.tableProps.page = 1
      this.$nextTick(() => {
        this.fetch();
      })
    },
    onPagination(e) {
      if (e !== this.page) {
        this.tableProps.page = e
        this.$nextTick(() => {
          this.fetch()
        })
      }
    },
    findModel() {
      if (this.value == null) return;

      this.loading = true;

      qrAxios.get(`manufacturers/${this.value}`)
          .then(({data}) => this.model = data)
          .catch(({response}) => this.$root.$emit('errorToast', response.data.message))
          .finally(() => this.loading = false);
    },
    pick(x) {
      // this.packTitle=x.title
      this.$emit('packSelected', x.id);
      this.$emit('packSelectedTitle', x.title);
      this.model = x;
      this.dialog = false;
    }
  }
}
</script>

<style scoped>

</style>
